import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import { useAthleteAuthContext } from "./login/useAthleteAuthContext";
import AthleteLayout from "./common/AthleteLayout";
import welcomeAmax from "../images/welcomeAmax.jpg";

import training from "../images/training-products.jpg";
import mySplit from "../images/my-split.jpg";
import become from "../images/become-athlete.jpg";
import runRocket from "../images/ASTdashboardpage.png";

export const AthleteDashboard = () => {
  const [showIntroVideo, setShowIntroVideo] = useState(false);

  const INTRO_VIDEO_URL =
    "https://www.youtube.com/embed/uu7j_xljCRY?si=63dt08MoV8UcuLAp";

  const { athlete } = useAthleteAuthContext();
  const [selectedStat, setSelectedStat] = useState("Stat A");

  const isUpgraded = athlete.account_type === "AMAX COACHED";

  const cards = [
    // CARD 1 — Welcome (only for non-upgraded users)
    // !isUpgraded && {
    //   title: "Welcome to AMAX",
    //   subtitle: "AMAX",
    //   description:
    //     "Start your training journey with our top tools, programs, and coaching options.",
    //   image: welcomeAmax,
    //   isIntroVideo: true, // 👈 flag
    //   bgColor: "#161616",
    // },



      // CARD 5 — Run Rocket
      {
        title: "AST Speed Profile™",
        subtitle: "AST Speed Profile™",
        description:
          "Force–Velocity Profiling: Get an elite-level assessment of your power output and receive custom workout recommendations based on your sprint mechanics.",
        image: runRocket,
        link: "/athlete/purchase-astspeedprofile-tool",
        bgColor: "#D55C48",
      },

         // CARD 3 — Training Products
    {
      title: "Training Products",
      subtitle: "Products",
      description:
        "Access structured speed & strength programs designed to improve performance anytime, anywhere.",
      image: training,
      link: "/athlete/purchase/static-speed-templates",
      bgColor: "#0F766E",
    },

    // CARD 2 — Membership
    {
      title: "Become an AMAX Athlete",
      subtitle: "AMAX Athlete",
      description:
        "Unlock personalized training. Work 1-on-1 with AMAX coaches and receive custom weekly workouts built for your goals.",
      image: become,
      link: "/athlete/membership", // memberships / upgrade page
      bgColor: "#6D48C1",
    },

 

    // CARD 4 — MySplit
    {
      title: "My Split",
      subtitle: "Split",
      description:
        "Know Your Speed Instantly: Use the AMAX MySplit tool to measure your acceleration, top-end speed, and training targets. Try it free while your trial is active.",
      image: mySplit,
      link: "/athlete/mysplit",
      bgColor: "#161616",
    },

  
  ].filter(Boolean);

  return (
    <AthleteLayout>
      <div className="h-full flex flex-col bg-white">
        <div className="flex-1 overflow-y-auto">
          {/* dashboard content */}
          <div className="bg-white w-full max-w-2xl mx-auto h-inherit">
            {/* Welcome to AMAX */}
            <div className="p-5 !pb-3">
              <div onClick={() => setShowIntroVideo(true)} className="relative cursor-pointer h-48 xs:h-56 p-5 xs:p-8 flex items-end rounded-3xl overflow-hidden">
                <div className="absolute inset-0">
                  <img
                    src={welcomeAmax}
                    alt="welcomeAmax"
                    className="object-cover h-full w-full"
                  />
                </div>
                <div className="absolute inset-0 bg-black/30 z-[1]"></div>

                <div className="relative z-[2]">
                  <p className="text-white text-xl xs:text-2xl leading-none">
                    Welcome to AMAX
                  </p>
                </div>
              </div>
            </div>

            {/* ATHLETE TRAINING OPTIONS */}
            <div className="p-5 pb-0 -mb-10">
              <div className="max-[479px]:w-[70%] w-[80%] pr-2">
                <p className="text-black text-xl xs:text-4xl !leading-snug uppercase border-b-2 border-yellow-600">
                  ATHLETE <br /> TRAINING OPTIONS
                </p>
              </div>

              <div></div>
            </div>

            <div className="p-5 pb-8 xs:pb-10 relative athlete-dashboard">
              {/* Map over the cards array to render each card dynamically */}
              <Swiper
                spaceBetween={28}
                // slidesPerView={1}
                modules={[Pagination]}
                pagination={{ clickable: true }}
                onSwiper={(swiper) => console.log(swiper)}
                breakpoints={{
                  320: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                  },
                }}
              >
                {cards.map((card, index) => {
                  const Wrapper = card.isIntroVideo ? "div" : Link;

                  return (
                    <SwiperSlide key={index}>
                      <Wrapper
                        to={!card.isIntroVideo ? card.link : undefined}
                        onClick={() => {
                          if (card.isIntroVideo) {
                            setShowIntroVideo(true);
                          }
                        }}
                        className={
                          card.isIntroVideo
                            ? "block cursor-pointer"
                            : "block relative"
                        }
                      >
                        {/* ⬇️ YOUR ORIGINAL DIV — UNCHANGED */}
                        <div
                          className="rounded-3xl min-h-80 xs:min-h-96 overflow-hidden relative flex items-end px-3 xs:px-5 py-8 xs:py-10"
                          // style={{ backgroundColor: card.bgColor }}
                        >
                          <div className="relative z-[2]">
                            <h2 className="text-white text-base xs:text-xl sm:text-2xl leading-tight capitalize">
                              {card.title} <br />
                            </h2>
                          </div>

                          <div className="absolute inset-0 z-0">
                            <img
                              src={card.image}
                              alt="card"
                              className="object-cover h-full w-full"
                            />
                          </div>

                          <div className="absolute inset-0 bg-black/40 z-[1]"></div>
                        </div>
                      </Wrapper>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          </div>
        </div>
      </div>

      {showIntroVideo && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80">
          {/* Close on backdrop click */}
          <div
            className="absolute inset-0"
            onClick={() => setShowIntroVideo(false)}
          />

          <div className="relative z-10 w-[90%] max-w-3xl bg-black rounded-xl overflow-hidden">
            {/* Close button */}
            <button
              className="absolute top-3 right-3 text-white text-xl z-20 p-1.5 xs:p-2 bg-black rounded-full w-9 h-9 xs:w-11 xs:h-11"
              onClick={() => setShowIntroVideo(false)}
            >
              ✕
            </button>

                  {/* Video Placeholder + iframe */}
                  <div className="relative w-full pt-[56.25%] bg-[#2A2A2A]">
                    {/* Placeholder */}
                    <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-[#2A2A2A] to-[#1A1A1A]">
                      <div className="text-center">
                        <div className="w-16 h-16 rounded-full border border-white/20 flex items-center justify-center mx-auto mb-3">
                          <div className="ml-1 border-l-[14px] border-l-white border-y-[10px] border-y-transparent" />
                        </div>

                        <p className="text-white/80 text-sm tracking-wide uppercase">
                          Intro Video Coming Soon
                        </p>
                      </div>
                    </div>

                    {/* Hidden iframe for future use */}
                    <iframe
                      src={INTRO_VIDEO_URL}
                      title="AMAX Introduction"
                      className="absolute inset-0 w-full h-full opacity-0 pointer-events-none"
                      frameBorder="0"
                      allow="autoplay; encrypted-media"
                      allowFullScreen
                    />
                  </div>
          </div>
        </div>
      )}
    </AthleteLayout>
  );
};
